import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Store } from '@ngxs/store';
import { RefreshTokenTimeDifference } from 'master-locations-library/master-locations-library/src/lib/core/domain/constants/application-constants';
import {
  Authorize,
  RefreshToken,
} from 'master-locations-library/master-locations-library/src/lib/core/domain/models';
import { RefreshTokenUseCase } from 'master-locations-library/master-locations-library/src/lib/core/usecases';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  Login,
    ResetAllStates,
    SetAuthorize, ViewCardSettings
} from '../../../state/master-locations-global.actions';
import { MasterLocationsGlobalState } from '../../../state/master-locations-global.state';

@Injectable({ providedIn: 'root' })
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(
    private store: Store,
    private router: Router,
    private refreshTokeUseCase: RefreshTokenUseCase
  ) {}

  private isRefreshing = false;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authorize = this.store.selectSnapshot<Authorize | undefined>(
      MasterLocationsGlobalState.Authorize
    );
    const jwtHelper = new JwtHelperService();
    const isAuthenticated = authorize && authorize.token;

    if (isAuthenticated) {
      const expiration = jwtHelper.getTokenExpirationDate(authorize!.token)!;
      let date = new Date();

      const milliDiff: number = expiration.getTime() - date.getTime();

      const totalSeconds = Math.floor(milliDiff / 1000);

      const totalMinutes = Math.floor(totalSeconds / 60);

      if (totalMinutes <= RefreshTokenTimeDifference && !this.isRefreshing) {
        this.isRefreshing = true;

        let body = new RefreshToken();
        body.userName = authorize!.username;

        this.refreshTokeUseCase.execute(body).subscribe((value) => {
          let newRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${value.token}`,
            },
          });

          this.isRefreshing = false;

          this.store.dispatch(new SetAuthorize(value));

          return next.handle(newRequest);
        });
      }

      const request = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authorize!.token}`,
        },
      });

      return next.handle(request).pipe(
        catchError((error: any) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            this.logout();
          }

          return throwError(() => error);
        })
      );
    }

    return next.handle(req);
  }

  logout() {
    // Unauthorized error, redirect to login page
    this.store.dispatch(new ResetAllStates());
    this.store.dispatch(new Login(undefined));
    this.store.dispatch(new ViewCardSettings('normalView'));
    this.router.navigate(["/accounts/login"]).then();

   }   
}
